var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix mg_bot50",attrs:{"id":"withdrawal_pages"}},[_c('base-deposit-withdraw-history',{attrs:{"type":"withdraw"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }